import Storage from "./Storage";

export default function Logout() {
    Storage.clear();
    window.location.replace('/');
}

export function FormatDate(dateString) {
    const d = new Date(dateString);
    return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear().toString().slice(2)}`
}

export function FormatCents(cents) {
    return Number(cents / 100).toLocaleString();
}

export function FormatManifestNumber(manifestNum, user) {
    let userShortcut = user;
    if (user === 'Boxberry') {
        userShortcut = 'BXB'
    }
    if (user === 'NovaPoshta') {
        userShortcut = 'NPI'
    }
    return `${userShortcut}-${manifestNum}`
}